// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/root/workspace/csida-studio_8pD0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import TeamOutlined from '/root/workspace/csida-studio_8pD0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TeamOutlined';
import UserOutlined from '/root/workspace/csida-studio_8pD0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
export default { DashboardOutlined, TeamOutlined, UserOutlined };
